enum Roles {
  Director = "Director",
  Manager = "Manager",
  ProgramContact = "Program Contact",
  AccredApplicant = "Accreditation Applicant",
  MasterTrainer = "Master Trainer",
  Instructor = "Instructor",
  AssessmentProctor = "Assessment Proctor",
  CertifiedAssessProc = "Certified Assessment Proctor",
  ModuleTestProctor = "Module Test Proctor",
  AssessPerfEvaluator = "Assessment Performance Evaluator",
  CurricPerfEvaluator = "Curriculum Performance Evaluator",
  MobileCranePracExaminer = "Mobile Crane Practical Examiner",
  RigSigPersonPracExaminer = "Rigger/Signal Person Practical Examiner",
  Learner = "Learner",
  Purchaser = "Purchaser",
  AccountsPayable = "Accounts Payable",
  Facilitator = "Facilitator",

  // CraftPro Roles
  CraftProLearner = "Craft Pro Learner",
  CraftProJobsiteEvaluator = "CraftPro Jobsite Evaluator",
  CraftProAdmin = "Craft Pro Admin",
}
export default Roles;
